import React, { useState, useEffect } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';
import useInitUserData from '../hooks/useInitUserData';

import { translatedMessage } from '../service/LanguageService';
import ApiService from '../service/ApiService';


import FooterBeforeLogin from '../components/FooterBeforeLogin';
import { ProgressSpinner } from 'primereact/progressspinner';

const SsoLogin = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const { token } = useParams();
    const initUserData = useInitUserData();
    const [errorMessage, setErrorMessage] = useState(null);
    const [userNotFound, setUserNotFound] = useState(false);

    useEffect(() => {
        setIsLoading(true)

        checkToken(token)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    const checkToken = async (token) => {
        // console.log("SSO Login with token:", token);
        ApiService.instance.post(`/tokenExternalAuth/${token}`)
            .then(async response => {
                if (response && response.status && response.data) {
                    userLogIn(response);
                }
            })
            .catch(error => {
                // console.log("Error during SSO login:", error);
                let _errorMessage = "login.error.generic";
                if (error && error.response && error.response.data && (error.response.status === 404 || error.response.status === 401)) {
                    _errorMessage = error.response.data
                    if (error.response.status === 401 && error.response.data === "error.user.not_found.forResponsible") {
                        setUserNotFound(true)
                    }
                } else {
                    if (error && error.response && error.response.data?.message) {
                        _errorMessage = error.response.data.message
                    }
                }
                // console.log("Error message during SSO login:", _errorMessage);
                setErrorMessage(_errorMessage);
                setIsLoading(false)
            })
    }

    const userLogIn = async (token) => {
        await ApiService.persistToken(token.data);
        await initUserData()
            .then(() => navigate('/home'))
            .catch(error => {
                let _errorMessage = "generic.error.get.data";
                if (error && error.response && error.response.data && error.response.data.message) {
                    _errorMessage = error.response.data.message
                }
                setErrorMessage(_errorMessage);
                setIsLoading(false)
            });
    }

    return (
        <>
            <div className="pages-body login-page flex flex-column before-login-pages">
                <div className='pcn-login-logos w-full flex justify-content-center py-1'></div>
                <div className="align-self-center mt-auto mb-auto">
                    {isLoading && <>
                        <div className="text-center">
                            <h5 className="">{translatedMessage("user.institution.responsible.loading.message")}</h5>
                            <ProgressSpinner />
                        </div>
                    </>}
                    {!isLoading && errorMessage !== null && <>
                        <div className="text-center">
                            <h5>
                                {translatedMessage(errorMessage)}
                                {userNotFound && <>
                                    <span className='ml-2'><Link to="/register">{translatedMessage('register.register')}</Link></span>                                    
                                </>}
                            </h5>
                        </div>
                    </>}
                </div>
                <FooterBeforeLogin />
            </div>
        </>
    );
};

export default SsoLogin;
